import type { TQC2090_R01Params } from "../Api_TQC2090_R01";
import { TQC2090_R01_COMP_CD } from "../Dto_TQC2090_R01";
import type { TQC2090_R01Filter } from "../Store_TQC2090_R01";

const toInspectYm = (date: Date | undefined): string | undefined => {
	if (!date) return undefined;
	const month = `${date.getMonth() + 1}`.padStart(2, "0");
	return `${date.getFullYear()}-${month}`;
};

const toDateRange = (
	date: Date | undefined,
): Pick<TQC2090_R01Params, "startDate" | "endDate"> => {
	if (!date) return {};
	const year = date.getFullYear();
	const month = `${date.getMonth() + 1}`.padStart(2, "0");
	const lastDay = new Date(year, date.getMonth() + 1, 0).getDate();
	return {
		startDate: `${year}-${month}-01`,
		endDate: `${year}-${month}-${`${lastDay}`.padStart(2, "0")}`,
	};
};

/** 화면 필터를 TQC2090_R01 조회·출력 API 파라미터로 변환한다. */
export const createTQC2090_R01Params = (
	filter: TQC2090_R01Filter,
): TQC2090_R01Params => ({
	compCd: TQC2090_R01_COMP_CD,
	inspectYm: toInspectYm(filter.inspectYm),
	...toDateRange(filter.inspectYm),
	workplaceCd: filter.workplaceCd || undefined,
});
